import { useQuery } from '@moonpig/web-core-graphql'
import { useMemo } from 'react'
import type { ProductInfoProduct, SearchCriteria } from '../../types'
import { MoreLikeThisQuery } from '../moreLikeThis/__generated__/moreLikeThis'
import { MoreLikeThisGQL } from '../moreLikeThis/moreLikeThis'

export const DEFAULT_LIMIT = 12

type Props = {
  productId: string
  searchCriteria: SearchCriteria
  range: string | null
  limit?: number
}

export const useSameRangeQuery = ({
  productId,
  searchCriteria,
  range,
  limit = DEFAULT_LIMIT,
}: Props): { products: ProductInfoProduct[]; loading: boolean } => {
  const { data, loading } = useQuery<MoreLikeThisQuery>(MoreLikeThisGQL, {
    variables: {
      productKey: productId,
      filters: {
        ...(searchCriteria.filters.integerFilter && {
          integerFilter: searchCriteria.filters.integerFilter,
        }),
        groupedFacets: searchCriteria.filters.groupedFacets,
      },
      searchTerm: searchCriteria.searchTerm,
      range,
      limit,
      ...(searchCriteria.appliedIntents?.length && {
        appliedIntents: searchCriteria.appliedIntents.map(
          ({ intentId, value, ordinal }) => ({
            intentId,
            value,
            ordinal,
          }),
        ),
      }),
    },
    skip: !range,
  })

  const products = useMemo(() => {
    const moreLikeThis = data?.moreLikeThis

    return moreLikeThis
      ? moreLikeThis.filter(product => product.masterVariant.inStock)
      : []
  }, [data])

  return {
    products,
    loading,
  }
}
